// Create an empty object to contain elements
const nav = {};

/**
 * Navigation
 * @param {string} attr The attrbute to use
 */
export default function navigation(attr) {
  // Stop if nothing is passed
  if (!attr) return false;

  // Get elements with matching attribute
  const els = document.querySelectorAll(`[${attr}]`);

  // For each element, add to object with attribute value as property key
  els.forEach(el => nav[el.getAttribute(attr)] = el);

  // Trigger function
  listener();
}

/**
 * Event listeners
 */
function listener() {
  // Add click event listener to trigger
  nav.trigger.addEventListener('click', (e) => {
    // Toggle class on trigger
    e.currentTarget.classList.toggle('is-active');
    // Toggle class on nav
    nav.nav.classList.toggle('is-active');
  });
}
